export default __webpack_public_path__ + "static/media/purpleCalendarCircle.a59fe5a3.svg";